module.exports = __webpack_public_path__ + "img/top.b0b39ae6.png";